module.exports = __webpack_public_path__ + "img/home-popup-title3.724a9f0b.png";